import { Box, Checkbox, Chip, MenuItem, Select, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { Controller } from "react-hook-form";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import CustomDialog from "../CustomDialog";
import NullCheck from "components/NullCheck";

const MultipleSelectInput = ({
  control,
  title,
  name,
  required,
  errors,
  width,
  validation,
  options,
  disabled,
  defaultValue,
}) => {
  const { bt } = useBizTypeTranslation();
  const [openMassge, setOpenMassge] = useState(false);
  const error = errors ? errors[name]?.ref?.name : false;
  const massge = errors ? errors[name]?.message : "";

  return (
    <Stack>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue ?? []}
        rules={{
          required: required ? bt("REQUIRED") : false,
          pattern: { value: validation?.regex, message: bt(validation?.massge) },
        }}
        render={({ field: { onChange, value } }) => (
          <Select
            error={error === `${name}`}
            autoWidth
            multiple
            label={`${required ? "*" : ""}${bt(title)}`}
            disabled={disabled ?? false}
            sx={{ width: width ? width : 200, paddingX: 1, minWidth: 200 }}
            size="small"
            MenuProps={{ PaperProps: { style: { maxHeight: 250 } } }}
            defaultValue={defaultValue ?? []}
            value={Array.isArray(value) ? value : []}
            onChange={onChange}
            renderValue={(selected) => {
              const selectedOptions = options?.filter((option) => selected?.includes(option.id));
              const displayedOptions = selectedOptions.slice(0, 1);
              const remainingCount = selectedOptions?.length - displayedOptions?.length;

              return (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {displayedOptions?.map((option) => option.name)}
                  {remainingCount > 0
                    ? <Typography variant="body2" sx={{ alignSelf: "center", fontWeight: "bold" }}>
                      +{remainingCount}
                    </Typography>
                    : null
                  }
                </Box>
              );
            }}
          >
            {options?.map((option) => {
              return (
                <MenuItem
                  key={option.id}
                  sx={{ minWidth: width ? width : 200, padding: 0 }}
                  value={option.id}
                >
                  <Checkbox checked={value.includes(option.id)} />
                  {bt(option.name)}
                </MenuItem>
              );
            })}
          </Select>
        )}
      />

      <NullCheck valueForCheck={massge}>
        <CustomDialog
          title="ERROR"
          open={openMassge}
          width={300}
          onClose={() => setOpenMassge(false)}
          closeBtn="CLOSE"
        >
          <Stack alignItems="center">
            {massge}
          </Stack>
        </CustomDialog>
      </NullCheck>
    </Stack>
  );
};
export default MultipleSelectInput;
